/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit'
import { PayloadAction } from '@reduxjs/toolkit/dist/createAction'
import store from 'src/store'
import {
  builderSagaCommunications,
  clearAllStateCommunications,
} from 'src/helpers/redux'
import { actions as moduleActions } from './actions'
import * as moduleState from './state'
import moduleSagas from './sagas'
import * as moduleSelectors from './selectors'

// export type StreamMessage = Partial<
//   Omit<moduleState.IMemoryThreadMessage, 'content'>
// > & { content?: Partial<moduleState.IMemoryThreadMessage['content']> }

// const mergeStreamMessage = (
//   a?: moduleState.IMemoryThreadMessage,
//   b?: StreamMessage
// ): moduleState.IMemoryThreadMessage => ({
//   ...a,
//   ...b,
//   //@ts-ignore
//   content: {
//     ...a?.content,
//     ...b?.content,
//     toolInvocations: [
//       ...(a?.content?.toolInvocations || []),
//       ...(b?.content?.toolInvocations || []),
//     ],
//     parts: [...(a?.content?.parts || []), ...(b?.content?.parts || [])],
//   },
// })
export const slice = createSlice({
  name: moduleState.PREFIX,
  initialState: moduleState.initialState,
  reducers: {
    setWindow(
      state: moduleState.IState,
      action: PayloadAction<Partial<moduleState.IStateData['window']>>
    ) {
      state.data.window = { ...state.data.window, ...action.payload }
    },
    // setMessgesAppend(
    //   state: moduleState.IState,
    //   action: PayloadAction<moduleState.IStateData['messages']>
    // ) {
    //   state.data.messages = [...action.payload, ...state.data.messages]
    // },
    setStreamMessages(
      state: moduleState.IState,
      action: PayloadAction<{
        threadId: string
        message: any
      }>
    ) {
      // const { threadId, message } = action.payload
      // const stateMessage = state.data.streamMessages?.[threadId]
      // state.data.streamMessages[threadId] = mergeStreamMessage(
      //   stateMessage,
      //   message
      // )
    },
    // setStreamMessagesComplited(
    //   state: moduleState.IState,
    //   action: PayloadAction<{
    //     threadId: string
    //     message: StreamMessage
    //   }>
    // ) {
    //   const { threadId, message } = action.payload
    //   const streamMessage = mergeStreamMessage(
    //     state.data.streamMessages?.[threadId],
    //     message
    //   )

    //   state.data.threads.threads = state.data.threads.threads.map((thread) => {
    //     if (thread.id === action.payload.threadId) {
    //       return {
    //         ...thread,
    //         messages: {
    //           ...thread.messages,

    //           items: [
    //             { ...streamMessage },
    //             ...(thread.messages?.items ?? []),
    //           ] as moduleState.IMemoryThreadMessage[],
    //         },
    //       }
    //     }

    //     return thread
    //   })

    //   state.data.streamMessages[threadId] = undefined
    // },
    setStreamMessagesCancel(
      state: moduleState.IState,
      action: PayloadAction<{ threadId: string }>
    ) {
      const { threadId } = action.payload
      state.data.streamMessages[threadId] = undefined
    },
    // setStreamMessageTextAppend(
    //   state: moduleState.IState,
    //   action: PayloadAction<{ text: string }>
    // ) {
    //   if (state.data.streamMessage) {
    //     state.data.streamMessage.text += action.payload.text
    //   }
    // },
    setStreamMessageToolAppend(
      state: moduleState.IState
      // action: PayloadAction<moduleState>
    ) {
      // if (state.data.streamMessage) {
      //   if (!state.data.streamMessage?.tools) {
      //     state.data.streamMessage.tools = []
      //   }
      //   let updated = false
      //   state.data.streamMessage.tools.map((tool) => {
      //     if (tool.toolCallId === action.payload.toolCallId) {
      //       updated = true
      //       return { ...tool, ...action.payload }
      //     }
      //     return tool
      //   })
      //   if (!updated) {
      //     state.data.streamMessage.tools.push(action.payload)
      //   }
      // }
    },

    setToogleOpenWidnow(
      state: moduleState.IState
      // action: PayloadAction<void>
    ) {
      state.data.window.open = !state.data.window.open
    },
    setThreads(
      state: moduleState.IState,
      action: PayloadAction<moduleState.IStateData['threads']>
    ) {
      state.data.threads = action.payload
    },
    setThreadsAppend(
      state: moduleState.IState,
      action: PayloadAction<moduleState.IStateData['threads']>
    ) {
      // state.data.threads = {
      //   ...action.payload,
      //   threads: [...state.data.threads.threads, ...action.payload.threads],
      // }
      // state.data.threads.page = action.payload.page || 0
    },
    setThreadsNewItem(
      state: moduleState.IState,
      action: PayloadAction<moduleState.IStateData['threads'][number]>
    ) {
      state.data.threads = [...state.data.threads, action.payload]
    },
    setThreadsUpdate(
      state: moduleState.IState,
      action: PayloadAction<moduleState.IStateData['threads'][number]>
    ) {
      // state.data.threads.threads = state.data.threads.threads.map((item) => {
      //   if (item.id === action.payload?.id) {
      //     return action.payload
      //   }
      //   return item
      // })
    },
    setThreadsRemove(
      state: moduleState.IState,
      action: PayloadAction<{ id: string }>
    ) {
      // state.data.threads.threads = state.data.threads.threads.filter(
      //   (item) => item.id !== action.payload.id
      // )
    },
    setThreadsItemMessages(
      state: moduleState.IState,
      action: PayloadAction<{
        threadId: string
        messages: moduleState.IChatMessage[]
      }>
    ) {
      state.data.threads = state.data.threads.map((thread) => {
        if (thread.id === action.payload.threadId) {
          return {
            ...thread,
            messages: action.payload.messages,
          }
        }

        return thread
      })
    },
    setThreadsItemMessagesAppend(
      state: moduleState.IState,
      action: PayloadAction<{
        threadId: string
        message: moduleState.IChatMessage
      }>
    ) {
      state.data.threads = state.data.threads.map((thread) => {
        if (thread.id === action.payload.threadId) {
          return {
            ...thread,
            messages: [...thread.messages, action.payload.message],
          }
        }

        return thread
      })
    },
    setThreadsItemMessagesUpdate(
      state: moduleState.IState,
      action: PayloadAction<{
        threadId: string
        message: moduleState.IChatMessage
      }>
    ) {
      state.data.threads = state.data.threads.map((thread) => {
        if (thread.id === action.payload.threadId) {
          return {
            ...thread,
            messages: thread.messages.map((message) => {
              if (message.id === action.payload.message.id) {
                return { ...message, ...action.payload.message }
              }

              return message
            }),
          }
        }

        return thread
      })
    },
    setClear(state: moduleState.IState) {
      state.data = moduleState.getInitialData()
      clearAllStateCommunications(state.communication)
    },
  },
  extraReducers: (builder) => {
    builderSagaCommunications<moduleState.IState>(builder, moduleActions)
  },
})

export const setters = slice.actions
export const actions = moduleActions
export const reducers = { [moduleState.PREFIX]: slice.reducer }
export const sagas = moduleSagas
export const state = moduleState
export const selectors = moduleSelectors

export const injectStore = () => {
  store.injectReducer?.(moduleState.PREFIX, slice.reducer)
  store.injectSaga?.(moduleState.PREFIX, sagas)
}
